<template>
    <div class="class1">
        <b-container>
            <b-row class="py-4 justify-content-md-center">
                <b-col align-self="end" cols="12" md="auto">
                    <div class="h5 font-weight-bold text-primary">Recent Collections</div>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <RecentCollection 
                        imgSrc="https://i.imgur.com/7fVHdpa.jpg"
                        name="Rooftops"
                        :numberOfPlaces="5"
                        creator="Satoshi"
                    />
                    <RecentCollection
                        imgSrc="https://i.imgur.com/VVYHXwX.jpg"
                        name="Things to do in Manila"
                        description="From visiting museums, to dropping in on a pop-up, to purely just taking photo-op flicks..."
                        :numberOfPlaces="30"
                        creator="Juan"
                    />
                    <RecentCollection 
                        imgSrc="https://i.imgur.com/m6SNiJC.jpg"
                        name="Food Places I Recommend in New York"
                        :numberOfPlaces="13"
                        creator="Mary"
                    />
                </b-col>
                <b-col>
                    <RecentCollection 
                        imgSrc="https://i.imgur.com/UxMPKbe.jpg"
                        name="Lounge Spot After Office"
                        :numberOfPlaces="26"
                        creator="Alex"
                    />
                    <RecentCollection
                        imgSrc="https://i.imgur.com/aMHMiZd.png"
                        name="Intramuros Eats Faves"
                        :numberOfPlaces="18"
                        creator="Cathy"
                    />
                    <RecentCollection 
                        imgSrc="https://i.imgur.com/YhYWN3q.jpg"
                        name="Free Museums"
                        :numberOfPlaces="6"
                        creator="Jill"
                    />
                </b-col>
            </b-row>
            <b-row class="py-4 justify-content-md-center">
                <b-col align-self="end" cols="12" md="auto">
                    <b-link class="text-success">
                        Browse more collections
                    </b-link>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<style scoped>
.class1 {
    width: 100%;
}

</style>

<script>
import RecentCollection from './RecentCollection'

export default {
    components: {
        RecentCollection

    },
    data() {
        return {

        }
    }
}
</script>